module.exports = __webpack_public_path__ + "img/campus events.521ba4af.png";